const ERR_CHAIN_NOT_ADDED = 4902

module.exports = {
  defaultChainId: 1,
  ERR_CHAIN_NOT_ADDED
}
